"use client";
import { button as a } from "./recipes/button.js";
import { link as d } from "./recipes/link.js";
import { codeblock as e, code as i, table as r, sup as m, list as t, heading as n } from "./recipes/markdown.js";
import { cn as o } from "../utils.js";
const p = {
  markdownH1: o(n({ size: "lg" }), "mb-3"),
  markdownH2: o(n({ size: "md" }), "mb-2"),
  markdownP: o("mb-3 break-words whitespace-pre-wrap", "[&+ol,&+li]:mt-0"),
  markdownLi: o("[&_a]:break-words [&_a]:inline"),
  markdownUl: t({ style: "unordered" }),
  markdownOl: o(
    t({ style: "ordered" }),
    "[inset-inline-start:var(--start,0px)]",
    "[counter-reset:item_calc(var(--start,0)_-_1)]"
  ),
  markdownLink: o(
    d(),
    "text-inkeep-primary-stronger hover:text-inkeep-primary-strong",
    "dark:text-inkeep-expanded-primary-100 dark:hover:text-inkeep-expanded-primary-300"
  ),
  markdownSourceLink: m(),
  markdownTable: r({ slot: "root" }),
  markdownTh: r({ slot: "th" }),
  markdownTd: r({ slot: "td" }),
  markdownCode: i(),
  codeblockContainer: e({ slot: "container" }),
  codeblockHeader: e({ slot: "header" }),
  codeblockCopyButton: o(a({}), e({ slot: "copyButton" })),
  codeblockHighlighterWrapper: o(),
  codeblockHighlighter: e({ slot: "highlighter" }),
  codeblockCode: "font-mono",
  markdownInput: o("mr-1")
};
export {
  p as markdownStyles
};
